import React from 'react';
import styled, { css, useTheme } from 'styled-components';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import RatingWidget, { Wrapper } from '../../../../components/widget';
import Text from './text';

const useStarsColor = (starsTheme) => {
  const { standoutColor } = useTheme();
  switch (starsTheme) {
    case 'dark':
      return 'black';
    case 'light':
      return 'white';
    case 'standout':
      return standoutColor;
    case 'primary':
    default:
      return null;
  }
};

const StyledRatingWidget = styled(RatingWidget)`
  margin: 0;
  flex-grow: 1;

  ${Wrapper} {
    margin-bottom: 0;
    align-items: baseline;
    ${({ $withBorder }) => $withBorder && css`
      align-items: center;
    `}
  }
`;

const getComponent = (variant) => {
  switch (variant) {
    case 'text':
      return Text;
    case 'stars':
    case 'stars_with_border':
    default:
      return StyledRatingWidget;
  }
};

const Rating = ({
  id,
  columnWidth,
  title,
  starsTheme,
  variant,
  openLinkToReviewsPageInTab,
  rating,
  offset,
}) => {
  const starsColor = useStarsColor(starsTheme);
  const Component = getComponent(variant);
  return (
    <Column
      columnWidth={columnWidth}
      justify="center"
      offset={offset}
    >
      <Component
        key={id}
        starsColor={starsColor}
        $withBorder={variant === 'stars_with_border'}
        title={title}
        openLinkToReviewsPageInTab={openLinkToReviewsPageInTab}
        ratingIds={rating.map(({ id: ratingId }) => ratingId).filter(Boolean)}
      />
    </Column>
  );
};

export default Rating;
